export const PromotionCartStoreItemElementRelationTypeValues = ['DISCOUNTED', 'ADDED', 'DISCOUNT_PRODUCER'];
//# sourceMappingURL=PromotionCartStoreItemElementRelationType.js.map